/*
    Reordena las columnas definidas en el colDef de aggrid, utiliza un array para ordenar
    las columnas que tienen prioridad y agrega el resto al final:
    const priorityColumns = ["columna1", "columna2", "columna3", "columna4"];
 */
export const reorderColumns = (coldef, priorityColumns) => {
    return coldef
        .sort((a, b) => {
            const indexA = priorityColumns.indexOf(a.field);
            const indexB = priorityColumns.indexOf(b.field);

            if (indexA === -1 && indexB === -1) return 0; // Mantiene el orden original
            if (indexA === -1) return 1; // `a` va después si no está en priorityColumns
            if (indexB === -1) return -1; // `b` va después si no está en priorityColumns
            return indexA - indexB; // Ordena según priorityColumns
        });
}